import { render } from "./WidgetSupplyvet.vue?vue&type=template&id=46a98c78&scoped=true"
import script from "./WidgetSupplyvet.vue?vue&type=script&lang=js"
export * from "./WidgetSupplyvet.vue?vue&type=script&lang=js"

import "./WidgetSupplyvet.vue?vue&type=style&index=0&id=46a98c78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a98c78"]])

export default __exports__